import React, { Component } from "react";
import { Formik, Form } from "formik";
import firebase from "firebase/app";
import "firebase/auth";
import spots from "../../config/spots";
import SpotInput from "./SpotInput/index";
import SubmitButton from "./SubmitButton";
import SubmitContainer from "./SubmitContainer";

class NotificationsSpotForm extends Component {
  constructor(props) {
    super(props);
    this.state = { spotData: undefined };
  }

  setNotificationsSettings = data => {
    firebase
      .firestore()
      .collection("uid")
      .doc(firebase.auth().currentUser.uid)
      .set(data, { merge: true });
  };

  componentDidMount() {
    const { userId } = this.props;
    if (userId) {
      var docRef = firebase
        .firestore()
        .collection("uid")
        .doc(userId);
      var that = this;
      console.log("userId:", userId);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("user token:", doc.data().token);
            that.setState({
              spotData: doc.data()
            });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    }
  }

  render() {
    const { spotData } = this.state;
    return (
      <div>
        {spotData !== undefined ? (
          <>
            {" "}
            <p>Opt in to receive your wave notifcations</p>
            <Formik
              initialValues={spotData}
              //   validationSchema={SignupSchema}
              onSubmit={(values, { setSubmitting }) => {
                // same shape as initial values
                console.log(values);
                this.setNotificationsSettings(values);
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
                /* and other goodies */
              }) => (
                <Form>
                  {spots.map((spot, index) => (
                    <SpotInput
                      key={index}
                      spot={spot}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values}
                    />
                  ))}

                  <SubmitContainer>
                    {errors.password && touched.password && errors.password}
                    <SubmitButton type="submit" disabled={isSubmitting}>
                      Save Preferences
                    </SubmitButton>
                  </SubmitContainer>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <span>loading</span>
        )}
      </div>
    );
  }
}

export default NotificationsSpotForm;
